import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Country } from '../../interfaces/country';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../button/button.component';
import { CountrySelectionService } from '../../services/country-selection.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-country',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonComponent],
  templateUrl: './select-country.component.html',
  styleUrl: './select-country.component.scss'
})
export class SelectCountryComponent implements OnInit, OnDestroy {
  countries: Country[] = [];
  selectedIso: string | null = null;
  loading = true;
  private subscription: Subscription | null = null;
  private hasRedirected = false;

  constructor(
    private countrySelectionService: CountrySelectionService,
    private router: Router
  ) {}

  ngOnInit() {
    // Verificar si ya hay un país válido seleccionado
    const currentIso = this.countrySelectionService.getSelectedCountryIso();
    if (currentIso) {
      // Si hay ISO en localStorage, verificar si es válido y redirigir
      this.subscription = this.countrySelectionService.countries$.subscribe(countries => {
        if (countries.length > 0 && countries.some(c => c.isoCode === currentIso) && !this.hasRedirected) {
          this.hasRedirected = true;
          this.router.navigate(['/']);
          return;
        }
      });
    }

    // Suscribirse al observable de países
    this.subscription = this.countrySelectionService.countries$.subscribe(countries => {
      if (countries.length > 0) {
        this.countries = countries;
        this.loading = false;
        
        // Si hay un país seleccionado, verificar si existe en la lista
        const currentIso = this.countrySelectionService.getSelectedCountryIso();
        if (currentIso) {
          if (countries.some(c => c.isoCode === currentIso)) {
            this.selectedIso = currentIso;
          } else {
            // Si no existe, eliminar el país seleccionado
            this.countrySelectionService.clearSelectedCountry();
            this.selectedIso = null;
          }
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  confirmCountry() {
    if (!this.selectedIso) return;

    // Usar el servicio para establecer el país
    this.countrySelectionService.setSelectedCountry(this.selectedIso);
    this.router.navigate(['/']);
  }
}
